import { API, graphqlOperation } from '@aws-amplify/api'
import * as queries from '../graphql/queries'

export const quotesByTenantId = /* GraphQL */ `
  query QuotesByTenantId(
    $tenantId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelQuoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    quotesByTenantId(
      tenantId: $tenantId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        tenantId
        quoteType
        childFreelancers
        offlineIds
        activeFlag
        type
        parentProjectId
        billLocation
        marginPercentage
        overheadPercentage
        exchangeRate
        allowInternational
        freelancers
        parentCompanyId
        maximizeMinimize
        clientName
        projectName
        agency
        agencyRepresentative
        director
        executiveProducer
        lineProducer
        numberOfShootingDays
        notes
        introduction
        shooting
        prep
        shootingCountry
        prelight
        casting
        crew
        buyouts
        locations
        studio
        artDepartment
        wardrobe
        equipment
        travel
        accommodation
        editing
        imagePostproduction
        soundPostproduction
        deliverables
        insurance
        quoteGuidelines
        excluded
        paymentTerms
        miscellaneous
        installment1Percentage
        installment1Date
        installment2Percentage
        installment2Date
        balancePercentage
        balanceDate
        isStarred
        isChecked
        recapInfoComments
        contact
        discount {
          totalDiscount
          totalAfterDiscount
          totalDiscountOnMargin
          totalDiscountOnMarginPercentage
          totalDiscountPercentage
        }
        advertiserJobID
        brand
        jobName
        agencyJobID
        product
        advertiser
        productionJobID
        advertiserAddress
        productionCompany
        productionContact
        vfxCo
        vfxProducer
        editorialCo
        editorialProducer
        musicCo
        musicProducer
        agencyProducer
        agencyCreativeTeam
        prepDays
        buildAndStrikeDays
        preLight
        stageDays
        locationDays
        createdOn
        updatedOn
        _version
        _deleted
        _lastChangedAt
      }
      nextToken
      startedAt
    }
  }
`

async function fetchClientsUtil(tenantId) {
  const clientsArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchClients = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.clientsByTenantId, {
        nextToken,
        tenantId,
        filter: { activeFlag: { eq: true } },
        limit: 1000,
      })
    )
    const clients = data.data.clientsByTenantId.items
    nextToken = data.data.clientsByTenantId.nextToken
    counter++
    clientsArray.push(...clients)
    return paginateFetchClients(nextToken)
  }
  await paginateFetchClients()
  return clientsArray
}

async function fetchProjectsByTenantIdUtil(tenantId) {
  const projectsArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchProjects = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.projectsByTenantId, {
        nextToken,
        tenantId,
        filter: { activeFlag: { eq: true } },
        limit: 1000,
      })
    )
    const projects = data.data.projectsByTenantId.items
    nextToken = data.data.projectsByTenantId.nextToken
    counter++
    projectsArray.push(...projects)
    return paginateFetchProjects(nextToken)
  }
  await paginateFetchProjects()
  return projectsArray
}

async function fetchArchiveProjectsByTenantIdUtil(tenantId) {
  const projectsArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchProjects = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.projectsByTenantId, {
        nextToken,
        tenantId,
        filter: {
          and: [{ type: { eq: 'archive' } }, { activeFlag: { eq: true } }],
        },
        limit: 1000,
      })
    )
    const projects = data.data.projectsByTenantId.items
    nextToken = data.data.projectsByTenantId.nextToken
    counter++
    projectsArray.push(...projects)
    return paginateFetchProjects(nextToken)
  }
  await paginateFetchProjects()
  return projectsArray
}

async function fetchProjectsByClientIdUtil(parentClientId, filter) {
  const projectsArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchProjects = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.projectsByClientId, {
        nextToken,
        parentClientId,
        filter,
        limit: 1000,
      })
    )
    const projects = data.data.projectsByClientId.items
    nextToken = data.data.projectsByClientId.nextToken
    counter++
    projectsArray.push(...projects)
    return paginateFetchProjects(nextToken)
  }
  await paginateFetchProjects()
  return projectsArray
}

async function fetchProjectsByParentProjectIdUtil(parentProjectId, filter) {
  const projectsArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchProjects = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.projectsByParentProjectId, {
        nextToken,
        parentProjectId,
        filter,
        limit: 1000,
      })
    )
    const projects = data.data.projectsByParentProjectId.items
    nextToken = data.data.projectsByParentProjectId.nextToken
    counter++
    projectsArray.push(...projects)
    return paginateFetchProjects(nextToken)
  }
  await paginateFetchProjects()
  return projectsArray
}

async function fetchQuotesByTenantIdUtil(tenantId) {
  const quotesArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchQuotes = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }

    const data = await API.graphql(
      graphqlOperation(quotesByTenantId, {
        nextToken,
        tenantId,
        filter: { activeFlag: { eq: true } },
        limit: 1000,
      })
    )

    const projects = data.data.quotesByTenantId.items
    nextToken = data.data.quotesByTenantId.nextToken
    counter++
    quotesArray.push(...projects)
    return paginateFetchQuotes(nextToken)
  }
  await paginateFetchQuotes()
  return quotesArray
}

async function fetchQuotesByParentProjectIdUtil(parentProjectId, filter) {
  const quotesArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchQuotes = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.quotesByParentProjectId, {
        nextToken,
        parentProjectId,
        filter,
        limit: 1000,
      })
    )
    const quotes = data.data.quotesByParentProjectId.items
    nextToken = data.data.quotesByParentProjectId.nextToken
    counter++
    quotesArray.push(...quotes)
    return paginateFetchQuotes(nextToken)
  }
  await paginateFetchQuotes()
  return quotesArray
}

async function fetchQuoteInfoUtil(quoteId, filter) {
  const quoteInfoArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchQuoteInfo = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.quoteInfoByQuoteId, {
        nextToken,
        quoteId: quoteId,
        filter,
        limit: 1000,
      })
    )
    const quote = data.data.quoteInfoByQuoteId.items
    nextToken = data.data.quoteInfoByQuoteId.nextToken
    counter++
    quoteInfoArray.push(...quote)
    return paginateFetchQuoteInfo(nextToken)
  }
  await paginateFetchQuoteInfo()
  return quoteInfoArray
}

async function fetchRecapInfoUtil(quoteId, filter) {
  const recapInfoArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchRecapInfo = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.recapInfoInfoByQuoteId, {
        quoteId: quoteId,
        filter,
        limit: 3000,
      })
    )
    const recapQuote = data.data.recapInfoInfoByQuoteId.items
    nextToken = data.data.recapInfoInfoByQuoteId.nextToken
    counter++
    recapInfoArray.push(...recapQuote)
    return paginateFetchRecapInfo(nextToken)
  }

  await paginateFetchRecapInfo()
  return recapInfoArray
}

async function fetchRecapInfoWithActiveFlagFalse(quoteId) {
  const recapInfoArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchRecapInfo = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.recapInfoInfoByQuoteId, {
        quoteId: quoteId,
        limit: 3000,
      })
    )
    const recapQuote = data.data.recapInfoInfoByQuoteId.items
    nextToken = data.data.recapInfoInfoByQuoteId.nextToken
    counter++
    recapInfoArray.push(...recapQuote)
    return paginateFetchRecapInfo(nextToken)
  }

  await paginateFetchRecapInfo()
  return recapInfoArray
}

async function fetchFreelancerProjectUtil(tenantId) {
  const freelancerProjectArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchFreelancersProjects = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.listProjectss, {
        nextToken,
        filter: {
          and: [{ activeFlag: { eq: true } }, { freelancers: { contains: tenantId } }],
        },
        limit: 1000,
      })
    )

    const freelancerProjects = data.data.listProjectss.items
    nextToken = data.data.listProjectss.nextToken
    counter++
    freelancerProjectArray.push(...freelancerProjects)
    return paginateFetchFreelancersProjects(nextToken)
  }
  await paginateFetchFreelancersProjects()

  return freelancerProjectArray
}

async function fetchChildFreelancerProjectUtil(tenantId) {
  const childFreelancerProjectArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchChildFreelancersProjects = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.listProjectss, {
        nextToken,
        filter: {
          and: [{ activeFlag: { eq: true } }, { childFreelancers: { contains: tenantId } }],
        },
        limit: 1000,
      })
    )

    const childFreelancerProjects = data.data.listProjectss.items
    nextToken = data.data.listProjectss.nextToken
    counter++
    childFreelancerProjectArray.push(...childFreelancerProjects)
    return paginateFetchChildFreelancersProjects(nextToken)
  }
  await paginateFetchChildFreelancersProjects()

  return childFreelancerProjectArray
}

async function fetchSuppliersByTenantIdUtil(tenantId) {
  const suppliersArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchSuppliers = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.suppliersByTenantId, {
        nextToken,
        tenantId,
        filter: { activeFlag: { eq: true } },
        limit: 1000,
      })
    )
    const projects = data.data.suppliersByTenantId.items
    nextToken = data.data.suppliersByTenantId.nextToken
    counter++
    suppliersArray.push(...projects)
    return paginateFetchSuppliers(nextToken)
  }
  await paginateFetchSuppliers()
  return suppliersArray
}

async function fetchPurchasesByTenantIdUtil(tenantId) {
  const purchasesArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchPurchases = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.purchasesByTenantId, {
        nextToken,
        tenantId,
        filter: { activeFlag: { eq: true } },
        limit: 1000,
      })
    )
    const projects = data.data.purchasesByTenantId.items
    nextToken = data.data.purchasesByTenantId.nextToken
    counter++
    purchasesArray.push(...projects)
    return paginateFetchPurchases(nextToken)
  }
  await paginateFetchPurchases()
  return purchasesArray
}
async function fetchContactsByTenantIdUtil(tenantId) {
  const contactsArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchContacts = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.contactsByTenantId, {
        nextToken,
        tenantId,
        filter: { activeFlag: { eq: true } },
        limit: 1000,
      })
    )
    const projects = data.data.contactsByTenantId.items
    nextToken = data.data.contactsByTenantId.nextToken
    counter++
    contactsArray.push(...projects)
    return paginateFetchContacts(nextToken)
  }
  await paginateFetchContacts()
  return contactsArray
}
async function fetchProposalsByTenantIdUtil(tenantId) {
  const proposalsArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchProposals = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.proposalsByTenantId, {
        nextToken,
        tenantId,
        filter: { activeFlag: { eq: true } },
        limit: 1000,
      })
    )
    const projects = data.data.proposalsByTenantId.items
    nextToken = data.data.proposalsByTenantId.nextToken
    counter++
    proposalsArray.push(...projects)
    return paginateFetchProposals(nextToken)
  }
  await paginateFetchProposals()
  return proposalsArray
}
async function fetchInvoicesByTenantIdUtil(tenantId) {
  const invoicesArray = []
  let counter = 0
  // The api call paginates after 1000 items fetched this function is called to get all the values
  const paginateFetchInvoices = async (nextToken = null) => {
    if (counter > 0 && nextToken === null) {
      return
    }
    const data = await API.graphql(
      graphqlOperation(queries.invoicesByTenantId, {
        nextToken,
        tenantId,
        filter: { activeFlag: { eq: true } },
        limit: 1000,
      })
    )
    const projects = data.data.invoicesByTenantId.items
    nextToken = data.data.invoicesByTenantId.nextToken
    counter++
    invoicesArray.push(...projects)
    return paginateFetchInvoices(nextToken)
  }
  await paginateFetchInvoices()
  return invoicesArray
}

function getFetchFilter(userInfo) {
  let filter = {}
  if (userInfo?.groups.includes('companyAdmin')) {
    filter = {
      and: [{ activeFlag: { eq: true } }, { tenantId: { eq: userInfo.tenantId } }],
    }
  } else if (userInfo?.groups.includes('freelancer')) {
    filter = {
      and: [{ activeFlag: { eq: true } }, { childFreelancers: { contains: userInfo.tenantId } }],
    }
  }
  return filter
}

function checkIfQuoteIsAccessible(userInfo, quote) {
  let accessibleQuote = null
  if (userInfo?.groups.includes('companyAdmin')) {
    accessibleQuote = quote.tenantId === userInfo.tenantId ? quote : null
  } else if (userInfo?.groups.includes('freelancer')) {
    accessibleQuote = quote.childFreelancers.includes(userInfo.tenantId) ? quote : null
  }
  return accessibleQuote
}

export {
  fetchClientsUtil,
  fetchProjectsByTenantIdUtil,
  fetchArchiveProjectsByTenantIdUtil,
  fetchProjectsByClientIdUtil,
  fetchProjectsByParentProjectIdUtil,
  fetchQuotesByTenantIdUtil,
  fetchQuotesByParentProjectIdUtil,
  fetchQuoteInfoUtil,
  fetchRecapInfoUtil,
  fetchRecapInfoWithActiveFlagFalse,
  fetchFreelancerProjectUtil,
  fetchChildFreelancerProjectUtil,
  fetchSuppliersByTenantIdUtil,
  getFetchFilter,
  checkIfQuoteIsAccessible,
  fetchInvoicesByTenantIdUtil,
  fetchProposalsByTenantIdUtil,
  fetchContactsByTenantIdUtil,
  fetchPurchasesByTenantIdUtil,
}
